// extracted by mini-css-extract-plugin
export var equalColumn = "_fu-0";